var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.816,
    height: 23.918,
    viewBox: "0 0 25.816 23.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.79,37.986V22.443H6.154V18.808H3.7v2.845H0V38.776H15.938v-.79H.79ZM4.494,19.6h.869v2.055H4.494Z",
    transform: "translate(0 -18.808)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.976)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.369,21.653V18.808h-2.45v2.845H44.547v.79H58.283v2.371h-19.1v.79H59.073V21.653Zm-.79,0h-.869V19.6h.869Z",
    transform: "translate(-39.184 -18.808)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.123 7.98)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M344.335,184.373V177.11h-.79v7.263a4.347,4.347,0,1,0,.79,0Zm-.4,7.884A3.556,3.556,0,1,1,347.5,188.7,3.56,3.56,0,0,1,343.94,192.257Z",
    transform: "translate(-339.593 -177.11)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.074 17.201)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M418.749,361.943v-1.976h-.79v2.766h2.766v-.79Z",
    transform: "translate(-417.959 -359.967)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.903 8.113)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M156.733,179.722v2.371H159.1v-2.371Zm1.581,1.581h-.79v-.79h.79Z",
    transform: "translate(-156.733 -179.722)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.591 8.113)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M229.875,179.722v2.371h2.371v-2.371Zm1.581,1.581h-.79v-.79h.79Z",
    transform: "translate(-229.875 -179.722)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.279 8.113)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M303.018,179.722v2.371h2.371v-2.371ZM304.6,181.3h-.79v-.79h.79Z",
    transform: "translate(-303.018 -179.722)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.215 11.801)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M83.59,252.865v2.371h2.371v-2.371Zm1.581,1.581h-.79v-.79h.79v.79Z",
    transform: "translate(-83.59 -252.865)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.903 11.801)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M156.733,252.865v2.371H159.1v-2.371Zm1.581,1.581h-.79v-.79h.79Z",
    transform: "translate(-156.733 -252.865)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.591 11.801)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M229.875,252.865v2.371h2.371v-2.371Zm1.581,1.581h-.79v-.79h.79Z",
    transform: "translate(-229.875 -252.865)"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.279 11.801)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M303.018,252.865v2.371h2.371v-2.371Zm1.581,1.581h-.79v-.79h.79Z",
    transform: "translate(-303.018 -252.865)"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.215 15.488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M83.59,326.008v2.371h2.371v-2.371Zm1.581,1.581h-.79v-.79h.79v.79Z",
    transform: "translate(-83.59 -326.008)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.903 15.488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M156.733,326.008v2.371H159.1v-2.371Zm1.581,1.581h-.79v-.79h.79Z",
    transform: "translate(-156.733 -326.008)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.591 15.488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M229.875,326.008v2.371h2.371v-2.371Zm1.581,1.581h-.79v-.79h.79Z",
    transform: "translate(-229.875 -326.008)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar01);
export default __webpack_public_path__ + "static/media/Icon-Calendar-01.c1e9bd06f93e55f749ed1deaec2d6bc1.svg";
export { ForwardRef as ReactComponent };